import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';

import Swal, { SweetAlertResult } from "sweetalert2";

import { ComponentBase } from '@shared/component-base.component';
import { SessionManager } from './session-manager';

import { ProductModel } from '@models/ProductModel';
import { VendorModel, VendorStoreModel, VendorUserModel } from '@models/VendorModel';
import { GiftcardModel } from '@shared/models/GiftcardModel';
import { ProductSaleInfo } from '@models/ProductModel';
import { IBenefits, IQuantifiable } from '@models/Interfaces';
import { CustomerModel } from '@models/CustomerModel';
import { TicketModel } from '@shared/models/TicketModel';
import { CashlessModel, EventModel } from '@shared/models/EventModel';
import { CategoryProduct } from '@models/ProductModel';
import { CategoryModel } from '@shared/models/CategoryModel';
import { RecoverModel } from '@shared/models/RecoverModel';
import { TransactionModel } from '@shared/models/TransactionModel';


export interface IPageLogo {
    logo: string;
    isCustom: boolean;
}

@Injectable()
export class SharedService {

    // Singleton
    static shareInstance: SharedService;

    showPreLogin = false;

    SwalCustom = Swal.mixin({
        customClass: {
            confirmButton: "btn btn-modal-main",
            cancelButton: "btn btn-modal-second",
            // popup: 'animated tada'
        },
        allowOutsideClick: false,

        buttonsStyling: false,
        reverseButtons: true,
        // animation: false,
        focusConfirm: true,
    });

    private SwalCustomGivi = Swal.mixin({
        customClass: {
            confirmButton: "btn-custom-modal btn-primary-no-focus btn-wsm",
            cancelButton: "btn-custom-modal btn-outline-primary btn-wsm",
            // popup: 'animated tada'
        },
        allowOutsideClick: false,

        buttonsStyling: false,
        reverseButtons: true,
        // animation: false,
        focusConfirm: true,
    });

    //theme variable
    private darkTheme = false;

    private validSetOneSignal: boolean = false;

    constructor() {
        return (SharedService.shareInstance =
            SharedService.shareInstance || this);
    }

    showConfirmAlert(
        title: string,
        text: string,
        confirmButtonText = "Aceptar",
        cancelButtonText = "Cancelar"
    ): Promise<SweetAlertResult> {
        return this.SwalCustom.fire({
            title: title || " ",
            text: text,
            // icon: 'question',
            showCancelButton: true,

            cancelButtonText: cancelButtonText,
            confirmButtonText: confirmButtonText,

            allowOutsideClick: false,
        });
    }

    showConfirmAlertWithHtml(
        title: string,
        html: string,
        confirmButtonText = "Aceptar",
        cancelButtonText = "Cancelar"
    ): Promise<SweetAlertResult> {
        return this.SwalCustom.fire({
            title: title || " ",
            html: html,
            // icon: 'question',
            showCancelButton: !!cancelButtonText,

            cancelButtonText: cancelButtonText,
            confirmButtonText: confirmButtonText,

            allowOutsideClick: false,
        });
    }

    showOpenGiviWithHtml(
        title: string,
        textHtml: string,
        confirmButtonText?: string
    ): Promise<SweetAlertResult> {
        const allHtml = `<h4 style="margin-top:10px !important;">
                            <b>${title}</b>
                        </h4><br>
                        <img src="assets/images/boom1.png" width="150px" class="m-b-20">
                        <div class="m-b-20" style="color: #6c757d !important;">${textHtml}</div>`;

        return this.SwalCustomGivi.fire({
            title: "",
            html: allHtml,
            confirmButtonText: confirmButtonText,
            showConfirmButton: !!confirmButtonText,

            allowOutsideClick: false,
        });
    }

    showBoomGiviAssigned(): Promise<SweetAlertResult> {
        const allHtml = `<h4 style="margin-top:10px !important;">
            <b>¡Boom! Givi Asignado</b>
            </h4><br>
            <img src="assets/images/boom1.png" width="250px" class="m-b-20">`;

        return this.SwalCustomGivi.fire({
            title: "",
            html: allHtml,
            confirmButtonText: 'Ingresá para ver tu givi',
            showConfirmButton: true,
            allowOutsideClick: false,
            customClass: {
                confirmButton: 'custom-swal-button'
            }
        });
    }

    showOpenGiviWithHtmlBtn(
        title: string,
        textHtml: string,
        confirmButtonText?: string
    ): Promise<SweetAlertResult> {
        const allHtml = `<h4 style="margin-top:10px !important;">
                            <b>${title}</b>
                        </h4><br>
                        <img src="assets/images/boom1.png" width="150px" class="m-b-20">
                        <div class="m-b-20" style="color: #6c757d !important;">${textHtml}</div>`;

        return this.SwalCustomGivi.fire({
            title: "",
            html: allHtml,
            confirmButtonText: confirmButtonText,
            showConfirmButton: true,
            allowOutsideClick: false,
            customClass: {
                confirmButton: 'custom-swal-button'
            }
        });
    }

    showSuccessAlert(title: string, text: string): Promise<SweetAlertResult> {
        return this.SwalCustom.fire({
            title: title || " ",
            text: text,
            // icon: 'success',
            showCancelButton: false,

            confirmButtonText: "Aceptar",
            // closeOnConfirm: true
        });
    }

    showBITsAlert(
        title: string,
        text: string,
        secondText: string
    ): Promise<SweetAlertResult> {
        const allHtml = `<h4 style="margin-top: 10px !important;">
        <b>${title}</b>
        </h4><br>
        <div class="m-b-20" style="font-size: 16px;" >${text}</div>
        <div style="font-size: 14px;">${secondText}</div>`;

        const swalConfig = {
            title: '',
            html: allHtml,
            confirmButtonText: '<span style="font-size: 16px; padding: 20px; border-radius: 2px;">ENTENDIDO</span>',
            showConfirmButton: true,
            customClass: {
                confirmButton: 'btn btn-tag-primary-light', // Agrega la clase al botón
                content: 'custom-content',
            },
            allowOutsideClick: false,
        };

        return this.SwalCustomGivi.fire(swalConfig);
        //btn-tag-primary-light text-color-label
    }

    showWarningAlert(title: string, text: string): Promise<SweetAlertResult> {
        return this.SwalCustom.fire({
            title: title || " ",
            text: text,
            // icon: 'warning',
            showCancelButton: false,

            confirmButtonText: "Aceptar",
            // closeOnConfirm: true
        });
    }

    showErrorAlert(title: string, text: string): Promise<SweetAlertResult> {

        // Asegura que el loading se oculta antes de mostrar error
        this.setLoading(false);

        return this.SwalCustom.fire({
            title: title || " ",
            text: text,
            // icon: 'error',
            showCancelButton: false,

            confirmButtonText: "Aceptar",

            // closeOnConfirm: true
        });
    }

    showErrorAlertCoupon(
        title: string,
        text: string,
        btnContent: string
    ): Promise<SweetAlertResult> {
        return this.SwalCustom.fire({
            title: title || " ",
            text: text,
            // icon: 'error',
            showCancelButton: false,

            confirmButtonText: btnContent,

            // closeOnConfirm: true
        });
    }

    showInfoTicketsAlert(title: string, subtitle: string, text: string, isDarkMode: boolean = false): Promise<SweetAlertResult> {

        const allHtml = `<span><b>${subtitle}</b></span ><br>
        <div class="m-t-10" style="font-size: 16px;" >${text}</div>`;

        const popupClass = isDarkMode ? 'dark-pop' : '';

        return this.SwalCustom.fire({
            title: title || ' ',
            html: allHtml,
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: 'Cerrar',
            customClass: {
                popup: popupClass,
                cancelButton: 'btn-dark-custom'
            },
        });
    }



    // Sidebar visibility
    public loadingSubject: Subject<boolean> = new Subject<boolean>();

    public pageLogoSubject: Subject<IPageLogo> = new Subject<IPageLogo>();

    public pageTitleSubject: Subject<string> = new Subject<string>();

    public pageBackSubject: Subject<boolean> = new Subject<boolean>();

    public mainPageBackSubject: Subject<boolean> = new Subject<boolean>();

    public hideLoginSubject: Subject<boolean> = new Subject<boolean>();

    public logoutSubject: Subject<string> = new Subject<string>();

    public accountSubject: Subject<CustomerModel> =
        new Subject<CustomerModel>();

    public accountSubjectGSA: Subject<VendorUserModel> = new Subject<VendorUserModel>();

    public changeVariant: Subject<boolean> = new Subject<boolean>();

    public changeProductQuantity: Subject<IQuantifiable> =
        new Subject<IQuantifiable>();

    public deleteImage: Subject<string> = new Subject<string>();

    public showEmailModal: Subject<boolean> = new Subject<boolean>();

    public showLoginModal: Subject<boolean> = new Subject<boolean>();

    public showVideoGiviModal: Subject<boolean> = new Subject<boolean>();

    public showAcceptGiviModal: Subject<boolean> = new Subject<boolean>();

    public showGeneralVideoModal: Subject<boolean> = new Subject<boolean>();

    public showGetPointsModal: Subject<boolean> = new Subject<boolean>();

    public showNotificationModal: Subject<boolean> = new Subject<boolean>();

    public showGiviNoteModal: Subject<boolean> = new Subject<boolean>();

    public showBenefitDetailModal: Subject<IBenefits> = new Subject<IBenefits>();

    public hideFooter: Subject<boolean> = new Subject<boolean>();

    public hideNav: Subject<boolean> = new Subject<boolean>();

    public hideHamburgerMenu: Subject<boolean> = new Subject<boolean>();

    public showMenu: Subject<boolean> = new Subject<boolean>();

    public showGiftcardPurchaseModal: Subject<boolean> = new Subject<boolean>();

    public showProductPurchaseModal: Subject<boolean> = new Subject<boolean>();

    public showTicketPurchaseModal: Subject<boolean> = new Subject<boolean>();

    public showCategoryProductsModal: Subject<CategoryModel> =
        new Subject<CategoryModel>();

    public showCategoryTicketsModal: Subject<CategoryModel> =
        new Subject<CategoryModel>();

    public showVendorTicketsModal: Subject<VendorModel> = new Subject<VendorModel>();

    public showDetailedCategoryModal: Subject<CategoryModel> = new Subject<CategoryModel>();

    public showVendorProductsModal: Subject<VendorModel> = new Subject<VendorModel>();

    public showStoreProductsModal: Subject<VendorModel> = new Subject<VendorModel>();

    public giftcardForModal: Subject<GiftcardModel> = new Subject<GiftcardModel>();

    public searchPopMarketplace: Subject<string> = new Subject<string>();

    public membershipForModal: Subject<GiftcardModel> = new Subject<GiftcardModel>();

    public showVerifyCardModal: Subject<TransactionModel> = new Subject<TransactionModel>();

    public productForModal: Subject<ProductModel> = new Subject<ProductModel>();

    public eventForModal: Subject<EventModel> = new Subject<EventModel>();

    public cashlessModal: Subject<CashlessModel> = new Subject<CashlessModel>();

    public storeForModal: Subject<VendorStoreModel> =
        new Subject<VendorStoreModel>();

    public addProduct: Subject<ProductSaleInfo> =
        new Subject<ProductSaleInfo>();

    public filterFromCategory: Subject<boolean> = new Subject<boolean>();

    public filterFromProduct: Subject<boolean> = new Subject<boolean>();

    public showDesktopProductModal: Subject<ProductModel> =
        new Subject<ProductModel>();

    public giftcardWatched: Subject<GiftcardModel> =
        new Subject<GiftcardModel>();

    public productWatched: Subject<ProductModel> = new Subject<ProductModel>();

    public ticketWatched: Subject<TicketModel> = new Subject<TicketModel>();

    public darkThemeSubject: Subject<boolean> = new Subject<boolean>();

    public showHeaderNav: Subject<boolean> = new Subject<boolean>();

    public isGiviScanApp: Subject<boolean> = new Subject<boolean>();
    public gsaLogo: Subject<string> = new Subject<string>();

    private behaviorQuantitySelectedTickets = new BehaviorSubject<number>(0);

    private _currentView: ComponentBase;

    private behaviorBackIsDarkMode = new BehaviorSubject<boolean>(false);

    private behaviorRecoverAt = new BehaviorSubject<RecoverModel>(null);

    public showVerifyAccountModal: Subject<boolean> = new Subject<boolean>();

    public wantToRedeemId: Subject<number> = new Subject<number>();

    setShowEmailModal(change: boolean): void {
        this.showEmailModal.next(change);
    }

    setShowLoginModal(change: boolean): void {
        this.showLoginModal.next(change);
    }

    setShowVideoGiviModal(change: boolean): void {
        this.showVideoGiviModal.next(change);
    }

    setShowAcceptGiviModal(change: boolean): void {
        this.showAcceptGiviModal.next(change);
    }

    setShowGeneralVideoModal(change: boolean): void {
        this.showGeneralVideoModal.next(change);
    }

    setShowGetPointsModal(change: boolean): void {
        this.showGetPointsModal.next(change);
    }

    setShowNotificationModal(change: boolean): void {
        this.showNotificationModal.next(change);
    }

    setShowGiviNoteModalModal(change: boolean): void {
        this.showGiviNoteModal.next(change);
    }

    setShowBenefitDetailModal(change: IBenefits): void {
        this.showBenefitDetailModal.next(change);
    }

    setHideFooter(change: boolean): void {
        this.hideFooter.next(change);
    }

    setHideNav(change: boolean): void {
        this.hideNav.next(change);
    }

    setHideHamburgerMenu(change: boolean): void {
        this.hideHamburgerMenu.next(change);
    }

    setShowMenu(showMenu: boolean): void {
        this.showMenu.next(showMenu);
    }

    setShowGiftcardPurchaseModal(change: boolean): void {
        this.showGiftcardPurchaseModal.next(change);
    }

    setShowProductPurchaseModal(change: boolean): void {
        this.showProductPurchaseModal.next(change);
    }

    setShowTicketPurchaseModal(change: boolean): void {
        this.showTicketPurchaseModal.next(change);
    }

    setShowCategoryProductsModal(category: CategoryProduct) {
        this.showCategoryProductsModal.next(category);
    }

    setShowCategoryTicketsModal(category: CategoryProduct) {
        this.showCategoryTicketsModal.next(category);
    }

    setShowDetailedCategoryModal(category: CategoryModel) {

        this.showDetailedCategoryModal.next(category);
    }

    setShowVendorProductsModal(vendor: VendorModel) {
        this.showVendorProductsModal.next(vendor);
    }

    setShowStoreModal(vendor: VendorModel) {

        this.showStoreProductsModal.next(vendor);
    }

    setShowVendorTicketsModal(vendor: VendorModel) {
        this.showVendorTicketsModal.next(vendor);
    }

    setShowVerifyCardModal(sale: TransactionModel) {

        this.showVerifyCardModal.next(sale);
    }

    setFilterFromCategory(change: boolean): void {
        this.filterFromCategory.next(change);
    }

    setFilterFromProduct(change: boolean): void {
        this.filterFromProduct.next(change);
    }

    setShowVerifyAccountModal(change: boolean): void {
        this.showVerifyAccountModal.next(change);
    }

    setWantToRedeemId(wantToRedeemId: number): void {
        this.wantToRedeemId.next(wantToRedeemId);
    }

    setGiftcardForModal(giftcard: GiftcardModel): void {
        this.giftcardForModal.next(giftcard);
    }
    
    
    setSearchPopMarketplace(text: string): void {
        this.searchPopMarketplace.next(text);
    }

    setMembershipForModal(giftcard: GiftcardModel): void {
        this.membershipForModal.next(giftcard);
    }

    setProductForModal(product: ProductModel): void {
        this.productForModal.next(product);
    }

    setEventForModal(event: EventModel): void {
        this.eventForModal.next(event);
    }

    setCashlessModal(cashlessModal: CashlessModel): void {
        this.cashlessModal.next(cashlessModal);
    }

    setGiftcardWatched(change: GiftcardModel): void {
        this.giftcardWatched.next(change);
    }

    setProductWatched(change: ProductModel): void {
        this.productWatched.next(change);
    }

    setTicketWatched(change: TicketModel): void {
        this.ticketWatched.next(change);
    }

    setIsGiViScan(isGiviScan: boolean): void {

        this.isGiviScanApp.next(isGiviScan);
    }

    setShowHeaderNav(showNav: boolean): void {

        this.showHeaderNav.next(showNav);
    }

    setGiviScanLogo(logoUrl: string): void {

        this.gsaLogo.next(logoUrl);
    }

    setChangeProductQuantity(model: IQuantifiable) {
        this.changeProductQuantity.next(model);
    }

    setDeleteImage(image: string): void {
        this.deleteImage.next(image);
    }

    setChangeVariant(change: boolean): void {
        this.changeVariant.next(change);
    }

    // Guardamos el timeout encolado del último setLoading(false) para poder
    // cancelarlo si llega un setLoading(true) antes de que se dispare.
    private _pendingLoaderHide: any = null;

    setLoading(loading: boolean): void {

        if (this.showPreLogin) return;

        if (loading) {
            // Cancelamos cualquier hide encolado — si viene un true, el loader
            // debe quedarse prendido y no ser apagado 300ms después por un false
            // que quedó en cola de un flujo anterior.
            if (this._pendingLoaderHide) {
                clearTimeout(this._pendingLoaderHide);
                this._pendingLoaderHide = null;
            }
            this.loadingSubject.next(loading);
        } else {
            // Si ya hay un hide encolado, no encolamos otro.
            if (this._pendingLoaderHide) clearTimeout(this._pendingLoaderHide);
            this._pendingLoaderHide = setTimeout(() => {
                this._pendingLoaderHide = null;
                this.loadingSubject.next(loading);
            }, 300);
        }
    }

    setPageLogo(logo: string, isCustom = false): void {
        this.pageLogoSubject.next({ logo: logo, isCustom: isCustom });
    }

    setPageTitle(title: string): void {
        this.pageTitleSubject.next(title);
    }

    setPageBack(show: boolean): void {
        this.pageBackSubject.next(show);
    }

    setMainPageBack(show: boolean): void {
        this.mainPageBackSubject.next(show);
    }

    setHideLoginBtn(hide: boolean): void {
        this.hideLoginSubject.next(hide);
    }

    setAccount(user: CustomerModel): void {
        this.accountSubject.next(user);
    }

    setAccountGSA(user: VendorUserModel): void {

        this.accountSubjectGSA.next(user);
    }

    setShowAddProductAlert(addProduct: ProductSaleInfo): void {
        this.addProduct.next(addProduct);
    }

    setShowDesktopProductModal(product: ProductModel): void {
        this.showDesktopProductModal.next(product);
    }

    setCurrentView(view: ComponentBase): void {
        this._currentView = view;
    }

    getChangeBehaviorQuantitySelectedTickets() {
        return this.behaviorQuantitySelectedTickets.asObservable();
    }

    getBehaviorQuantitySelectedTickets(): number {
        return this.behaviorQuantitySelectedTickets.getValue();
    }

    setBehaviorQuantitySelectedTickets(valor: number) {
        this.behaviorQuantitySelectedTickets.next(valor);
    }

    allowNavigate(): Promise<boolean> {
        if (this._currentView && this._currentView.allowNavigate) {
            return this._currentView.allowNavigate();
        }
        return Promise.resolve(true);
    }

    getChangeBehaviorBackIsDarkMode() {
        return this.behaviorBackIsDarkMode.asObservable();
    }

    getBehaviorBackIsDarkMode(): boolean {
        return this.behaviorBackIsDarkMode.getValue();
    }

    setBehaviorBackIsDarkMode(valor: boolean) {
        this.behaviorBackIsDarkMode.next(valor);
    }

    getChangeBehaviorRecoverAt() {
        return this.behaviorRecoverAt.asObservable();
    }

    getBehaviorRecoverAt(): RecoverModel {
        return this.behaviorRecoverAt.getValue();
    }

    setBehaviorRecoverAt(valor: RecoverModel) {
        this.behaviorRecoverAt.next(valor);
    }

    showConnectionTimeoutAlert(): Promise<SweetAlertResult> {
        return this.SwalCustom.fire({
            title: " ", // Trick: added space to title for show margin top on message
            text: "No se pudo establecer conexión con el servidor, se irá a la página de login para iniciar sesión nuevamente",
            //icon: 'error',
            showCancelButton: false,

            confirmButtonText: "Aceptar",
            // closeOnConfirm: true
        }).then((result: SweetAlertResult) => {
            this.logoutSubject.next();
            return result;
        });
    }

    showSessionTimeoutAlert(
        errMsg = "Su sesión ha expirado, se irá a la página de login para iniciar sesión nuevamente"
    ): Promise<SweetAlertResult> {
        this.setLoading(false);

        return this.SwalCustom.fire({
            title: " ", // Trick: added space to title for show margin top on message
            text: errMsg,
            //icon: 'error',
            showCancelButton: false,

            confirmButtonText: "Aceptar",
            // closeOnConfirm: true
        }).then((result: SweetAlertResult) => {
            this.logoutSubject.next();
            return result;
        });
    }

    logout(): void {
        // clear session and remove from storage
        SessionManager.clearSession();
        // clear account on pages
        this.accountSubject.next(null);
        // enviar el logout a los subscriptores
        this.logoutSubject.next();

        // Check if the native functions are ready to be used
        // const nativeFunctions = window['nativeFunctions'];
        // if (nativeFunctions) {
        //     nativeFunctions.logout();
        // }
    }

    setMobiloudApp(app: any) {
        SessionManager.setMobiloudApp(app);
    }

    getMobiloudApp(): any {
        SessionManager.getMobiloudApp();
    }

    //enable/disable toggleTheme
    setDarkTheme(active: boolean) {

        this.darkTheme = active;
        this.darkThemeSubject.next(active);
    }

    // Public static method to retrieve the theme
    isDarkTheme(): boolean {
        return this.darkTheme;
    }

    setValidSetOneSignal(active: boolean) {

        this.validSetOneSignal = active;
    }

    isValidSetOneSignal(): boolean {
        return this.validSetOneSignal;
    }

    convertToBase64(url: string): Promise<any> {

        const headers = {
            "Cache-Control": "no-cache",
            "Access-Control-Allow-Headers": "Content-Type",
            "Access-Control-Allow-Methods": "GET,OPTIONS",
            "Access-Control-Allow-Origin": "*"
        };

        return fetch(url, { headers })
            .then(response => {
                return response.blob();
            })
            .then(blob => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();

                    reader.onload = () => {
                        const imageToBase64 = reader.result as string;
                        resolve(imageToBase64);
                    };

                    reader.onerror = (err) => {
                        reject(err);
                    };

                    reader.readAsDataURL(blob);
                });
            }).catch((err) => {
                console.log(err);
                return Promise.reject(err);
            });
    }

    /**
     * Traduce al español los mensajes de validación de Stripe.js.
     * Los rechazos del banco y el 3DS no están en la tabla porque el texto lo redacta
     * Stripe según el caso: en vez de taparlos con un genérico se muestra el mensaje
     * original, que es el único dato que dice por qué falló el cobro.
     * @param {string} message - El mensaje que devuelve Stripe.js.
     * @returns el mensaje traducido, o el original si no está en la tabla.
     */
    translateStripeError(message: string): string {

        const errors: { [key: string]: string } = {
            'Your card number is incomplete.': 'El número de la tarjeta está incompleto.',
            'Your card number is invalid.': 'El número de la tarjeta no es válido.',
            'Your card number is incorrect.': 'El número de la tarjeta es incorrecto.',
            'Your card’s expiration date is incomplete.': 'La fecha de expiración está incompleta.',
            'Your card’s security code is incomplete.': 'El código de seguridad está incompleto.',
            'Your card’s expiration year is in the past.': 'El año de expiración no es válido.',
            'Your card’s expiration date is in the past.': 'La fecha de expiración no es válido.',
            'Your card has expired.': 'La tarjeta ha expirado.',
            'Your card’s security code is invalid.': 'El CVC no es válido.',
            'An unexpected error occurred.': 'Ocurrió un error inesperado.',
            'Your card has insufficient funds.': 'La tarjeta no tiene fondos suficientes.',
            'Your card was declined.': 'La tarjeta fue rechazada.',
        };

        return errors[message] || message || 'Ocurrió un error con la tarjeta.';
    }
}
